/**
 * E-Mail-Protokoll API Client
 *
 * Erfüllt `EmailLogApiClient` (core-frontend `plugin-email-log`) mit dem
 * TYPISIERTEN tRPC-Client dieser App. `core-frontend` kennt den `AppRouter`
 * nicht — die Typprüfung passiert deshalb hier, wo er bekannt ist. Gleiches
 * Muster wie `govCredentialsClient` und `apiKeyClient`.
 *
 * Beide Prozeduren liegen im Kernel-Router `email` (core-backend) und tragen
 * das Entitlement `email:logs:read`, das der Kernel an Owner + Administrator
 * vergibt — die App gewährt dafür nichts.
 */

import type {
  EmailLogApiClient,
  EmailLogEntry,
  EmailLogFilters,
} from '@xhubio-saas/core-frontend/plugin-email-log'
import { useMemo } from 'react'
import { trpc } from '@/trpc'

export function useEmailLogClient(): EmailLogApiClient {
  const utils = trpc.useUtils()

  return useMemo(
    () => ({
      async queryOrganizationLogs(filters: EmailLogFilters): Promise<EmailLogEntry[]> {
        // Die Zeilen des Routers tragen mehr Felder als der Vertrag verlangt
        // (emailHash, cc/bcc, providerId, retentionUntil …). Das ist gewollt:
        // die geteilte Fläche zeigt nur, was sie auch erklären kann.
        return await utils.email.queryOrganizationLogs.fetch(filters)
      },

      async getProvider(): Promise<string> {
        return await utils.email.getProvider.fetch()
      },
    }),
    [utils]
  )
}
